import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { DocumentLink } from '../DocumentLink'

@InputType()
export class RevokeDocumentLinkArgs extends ActionArgs {
  @Field(() => ID)
  _id: string
}

export interface IRevokeDocumentLink extends IAction<DocumentLink, RevokeDocumentLinkArgs> {}
